/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './ColorSelector.styles.scss';

import ShareCardColorSwatch from './ShareCardColorSwatch';
import { Grid } from '../../../components/Grid';
import { useLists } from '../../../hooks/useLists';

interface Props {
  shareCard: any;
  onClick(c): void;
}
const ColorSelector: React.FC<Props> = (props) => {
  const [{ colorShareCardList }] = useLists();
  const colorId = props.shareCard.color_id;

  return (
    <div className="cmp-colorselector">
      <Grid justifyContent="space-between" alignItems="center" spacing="small" flexWrap="nowrap">
      {
        colorShareCardList.map((item) => (
          <ShareCardColorSwatch
            key={item.id}
            color={item.color}
            selected={colorId === item.id}
            onClick={() => {
              props.onClick(item);
            }}
          />
        ))
      }
      </Grid>
    </div>
  );
};

export default ColorSelector;
